<template>
  <div class="banner-blackout">
    <i class="icon sm rhg-font-icon--calendar"></i>
    <span class="banner-blackout__text">{{ text }}</span>
  </div>
</template>

<script>
export default {
  name: 'BlackoutBanner',
  props: {
    text: {
      type: String
    }
  }
}
</script>

<style lang="scss" scoped>
.banner-blackout {
  display: flex;
  align-items: center;
  background-color: #dbe3ec;
  padding: 12px;
  border-radius: 8px;
  width: 100%;

  @media (max-width: 992px) {
    margin: 0 12px 8px 12px;
    align-items: start;
    width: fit-content;
  }

  &__text {
    padding-inline: 8px;
    font-size: 14px;
  }
}
</style>
